"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFirstChannelUnreadThreadOpen = useFirstChannelUnreadThreadOpen;
var _react = require("react");
var _streamChatReact = require("stream-chat-react");
var _Messenger = require("../../../utils/Messenger");
function useFirstChannelUnreadThreadOpen() {
  var _useChannelStateConte = (0, _streamChatReact.useChannelStateContext)(),
    channel = _useChannelStateConte.channel,
    channelMessages = _useChannelStateConte.messages;
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    client = _useChatContext.client;
  (0, _react.useEffect)(function () {
    var _document$querySelect;
    var firstMyUnreadMessageThread = channelMessages.find(function (message) {
      return (0, _Messenger.isMyMessageWithUnreadReply)(message, client, channel);
    });
    if (!firstMyUnreadMessageThread) {
      return;
    }
    var messageRepliesButtonEl = (_document$querySelect = document.querySelector("[data-messageid='".concat(firstMyUnreadMessageThread.id, "']"))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector('.str-chat__message-replies-count-button');
    if (!messageRepliesButtonEl) {
      return;
    }
    messageRepliesButtonEl.click();
  }, []);
}